import { useSelector } from "react-redux"
import { selectCandidateProfile } from "../../../slice/candidateSlice"


export default function CoverLetterText() {
    const candidateData = useSelector(selectCandidateProfile)
    return (
        <div className="max-w-3xl mx-auto mt-[4rem] !min-h-[43rem] bg-white rounded-lg shadow-lg p-14 transition-all">
            <div className="space-y-2 text-base font-light leading-6 text-gray-600">
                {candidateData?.longSummary && candidateData?.longSummary?.length > 0 ? (
                    candidateData?.longSummary
                ) : (
                    <p className="italic text-gray-500">No cover letter content available.</p>
                )}
            </div>
        </div>
    )
}